/**
 * LaTeX symbol spans the concierge writes and their display characters. The chat's markdown has no
 * math support, so without this a reply shows `LAX $\rightarrow$ UBN` as code. These eight cover
 * nearly every LaTeX use in production concierge replies; any other LaTeX is left as written.
 */
const LATEX_SYMBOLS: ReadonlyArray<readonly [span: string, symbol: string]> = [
  ['$\\rightarrow$', '→'],
  ['$\\to$', '→'],
  ['$\\leftarrow$', '←'],
  ['$\\leftrightarrow$', '↔'],
  ['$\\times$', '×'],
  ['$\\div$', '÷'],
  ['$\\approx$', '≈'],
  ['$\\le$', '≤'],
];

/**
 * Replaces the known LaTeX symbol spans in chat text with their characters, for display and copy
 * only — stored messages keep the original text. A half-streamed span (`$\righta`) is left as is and
 * is replaced once the rest of it arrives.
 *
 * @example
 * replaceLatexSymbols('LAX $\\rightarrow$ UBN'); // 'LAX → UBN'
 */
export function replaceLatexSymbols(text: string): string {
  return LATEX_SYMBOLS.reduce((result, [span, symbol]) => result.replaceAll(span, symbol), text);
}
